import {
  CollectionIcon,
  DeliveryIcon,
  DiscountIcon,
  GiftCardIcon,
} from "@shopify/polaris-icons";

/** Public Crisp workspace identifier from the onboarding embed snippet. */
export const CRISP_WEBSITE_ID = "9510ce4f-098f-46e7-b5ad-14e9ec963bd4";

/**
 * Direct Crisp chat page; used when the embedded widget cannot be opened.
 *
 * Shared by every app variant — all variants use the same Crisp workspace, so
 * this is intentionally NOT part of per-variant branding.
 */
export const SUPPORT_CHAT_URL = `https://go.crisp.chat/chat/embed/?website_id=${CRISP_WEBSITE_ID}`;

export const AIOD_DOCS_URL = "https://aiodapp.com/docs";

export const DISCOUNT_ICON = {
  DISCOUNT: DiscountIcon,
  GIFT: GiftCardIcon,
  SHIPPING: DeliveryIcon,
  MULTI_DISCOUNT: CollectionIcon,
};

export const INTENT_GET_THEME_APP_EMBED_STATUS = "getThemeAppEmbedStatus";
export const INTENT_GET_INITIAL_LOAD_DATA = "getInitialLoadData";
export const INTENT_GET_CUSTOMER_SEGMENTS = "getCustomerSegments";
export const INTENT_GET_ACTIVE_DISCOUNTS = "getActiveDiscounts";
export const INTENT_SET_DISCOUNT_MODE = "setDiscountMode";
export const INTENT_RECORD_DISCOUNT_TEST_FLOW_EVENT =
  "recordDiscountTestFlowEvent";
export const INTENT_LOAD_USAGE_PRICING_RECORDS = "loadUsagePricingRecords";
export const INTENT_DELETE_BULK_CODES = "deleteBulkCodes";

export const MAX_METAFIELD_SIZE = 10; // 10 KB in bytes

export const DEMO_VIDEO_YT_ID = "iT3IQoOinIM";

export const SUBSCRIPTION_NEEDED_MESSAGE = "You need to subscribe to a paid plan for this feature.";

export const EARLY_USER_NEW_DISCOUNT_SUBSCRIPTION_TITLE = "Subscribe to create new discounts";
export const EARLY_USER_NEW_DISCOUNT_SUBSCRIPTION_MESSAGE =
  "Don't worry — every discount you've already created will keep running exactly as it is. You'll just need to subscribe to a paid plan to create new discounts.";
